import { reactive } from 'vue'

const backend = process.env.VUE_APP_BACKEND || "https://fieldgather.com";
const redirectUri = process.env.VUE_APP_REDIRECT_URI || "https://fieldgather.com";
const baseTiles = process.env.VUE_APP_BASE_TILE_SERVER || backend + "/api/tile/png/base/{z}/{x}/{y}";
const roadsTiles = process.env.VUE_APP_ROADS_TILE_SERVER || backend + "/api/tile/png/roads/{z}/{x}/{y}";

export const ConfigurationStore = reactive({
    auth: {
        authority: 'https://login.fieldgather.com/fieldgather.onmicrosoft.com/B2C_1_SignUpAndSignIn',
        clientId: 'bb8682fe-d0dd-41a0-9e34-b04d641d15c1',
        knownAuthorities: ["login.fieldgather.com"],
        redirectUri: redirectUri,
        scopes: ['https://fieldgather.onmicrosoft.com/api/surveys/survey.get']
    },
    backend: backend,
    map: {
        maxZoom: 22,
        minZoom: 3,
        textZoomLevel: 18,
        baseTileServer: baseTiles,
        roadsTileServer: roadsTiles
    }
})